<template>
  <b-container fluid>
    <b-overlay :show="loading">
    <b-row>
      <b-col lg="4" md="4" class="text-center">
        <span class="text-dark">
          {{ $t("sales_center.sales_center") }} : {{ getSalesCenterName(dataArray.sales_center_id) }}
        </span>
      </b-col>
      <b-col lg="4" md="4" class="text-center">
        <span class="text-dark">
          {{ $t("sales_center.demand_id") }} : {{ dataArray.demand_id }}
        </span>
      </b-col>
      <b-col lg="4" md="4" class="text-center">
        <span class="text-dark">
          {{ $t("sales_center.demand_date") }} : {{ dataArray.demand_date | dateFormat }}
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" sm="12" class="text-right">
        <b-button variant="primary" class="mr-2 mb-2" @click="checkGift()">{{ $t('retailerManagement.free_gift') }}</b-button>
      </b-col>
      <b-col lg="12" sm="12" v-if="givefree" class="mb-2">
        <ValidationObserver ref="form1" v-slot="{ handleSubmit, reset }">
          <b-form  @submit.prevent="handleSubmit(addProduct)" @reset.prevent="reset">
            <b-overlay :show="qtLoad">
              <b-row style="border-top: 1px solid #ddd;border-bottom: 1px solid #ddd; padding-top: 10px;">
                <b-col lg="4" sm="12">
                    <ValidationProvider name="Product Cagetory" vid="category_id" rules="required|min_value:1">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="category_id"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                            {{$t('production_store.pro_category')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                            plain
                            v-model="freeProduct.category_id"
                            :disabled="disableCat"
                            id="category_id"
                            :options="categoryList"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="4" sm="12">
                    <b-form-group
                        class="row"
                        label-cols-sm="12"
                        label-for="sub_category_id "
                        >
                        <template v-slot:label>
                        {{$t('production_store.pro_sub_category')}}
                        </template>
                        <b-form-select
                        plain
                        v-model="freeProduct.sub_category_id"
                        :disabled="disableSubCat"
                        id="sub_category_id"
                        :options="subCategoryList"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="4" sm="12">
                    <ValidationProvider name="Product" vid="product_id" rules="required|min_value:1">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="product_id"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                            {{$t('production_store.pro_name')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                            plain
                            v-model="freeProduct.product_id"
                            id="product_id"
                            :options="productNList"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="4" sm="12">
                    <ValidationProvider name="Unit" vid="unit_id" rules="required|min_value:1">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="unit_id"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                            {{$t('production_store.pro_unit')}} <span class="text-danger">*</span>
                            </template>
                            <b-form-select
                            plain
                            v-model="freeProduct.unit_id"
                            id="unit_id"
                            :options="productUnitList"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="4" sm="12">
                    <ValidationProvider name="Available Quantity" vid="available_quantity"  rules="required|numeric">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="available_quantity"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                                {{ $t('production_store.available_quantity') }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                                id="available_quantity"
                                v-model="freeProduct.available_quantity"
                                :state="errors[0] ? false : (valid ? true : null)"
                                :disabled="true"
                            ></b-form-input>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="4" sm="12">
                    <ValidationProvider name="Quantity" vid="delivery_quantity"  :rules="`required|numeric|min_value:1|max_value: ${freeProduct.available_quantity}`">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="delivery_quantity"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                                {{ $t('production_store.quantity') }} <span class="text-danger">*</span>
                            </template>
                            <b-form-input
                                id="delivery_quantity"
                                v-model="freeProduct.delivery_quantity"
                                :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-input>
                            <div class="invalid-feedback">
                                {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col lg="8"></b-col>
                <b-col lg="4" sm="12">
                    <div class="col text-right mb-2">
                        <b-button @click="addFreeProduct" variant="primary">{{ $t('globalTrans.add') }}</b-button>
                    </div>
                </b-col>
              </b-row>
            </b-overlay>
          </b-form>
        </ValidationObserver>
      </b-col>
      <b-col lg="12" sm="12" class="mt-4">
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
          <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
            <b-overlay :v-show="unitLoad">
              <table class="table table-bordered">
                <tr class="bg-light">
                  <th width="100px">{{ $t("globalTrans.sl_no") }}</th>
                  <th>{{ $t("production_store.pro_category") }}</th>
                  <th>{{ $t("production_store.pro_name") }}</th>
                  <th>{{ $t("production_store.unit") }}</th>
                  <th>{{ $t("retailerManagement.request_quantity") }}</th>
                  <th>{{ $t("sales_distribution_admin.delivered_quantity") }}</th>
                  <th>{{ $t("sales_distribution_admin.available_quantity") }}</th>
                  <th>{{ $t("retailerManagement.delivery_quantity") }}</th>
                  <th>{{ $t("sales_distribution_admin.unit_price") }}</th>
                  <th>{{ $t('retailerManagement.total_price') }}</th>
                </tr>
                <tr v-for="(item, index) in dataArray.details" :key="index">
                  <td style="width: 2%;">{{ $n(index + 1) }}</td>
                  <td>{{ getCategoryName(item.product_id) }}</td>
                  <td>{{ productNameById(item.product_id) }} <span v-if="item.is_free" class="badge badge-warning">{{ $t('retailerManagement.free') }}</span></td>
                  <td>{{ unitNameById(item.unit_id) }}</td>
                  <td>{{ $n(item.quantity) }}</td>
                  <td>{{ $n(item.delivered_quantity) }}</td>
                  <td>{{ $n(geAvailable (index)) }}</td>
                  <td>
                    <ValidationProvider name="Deliver Quantity" :rules="'max_value:' + geAvailable (index)">
                      <b-form-group
                        slot-scope="{ valid, errors }"
                      >
                        <b-form-input
                          type="number"
                          v-model="item.delivery_quantity"
                          @input="changeItemQty(item)"
                          :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider name="Unit Price" :rules="{required: true, regex: /^\d*\.?\d*$/}">
                          <b-form-group
                          slot-scope="{ valid, errors }"
                          >
                              <b-form-input
                              :readonly="dataArray.type_id == 1 ? true : false"
                              v-model="item.unit_price"
                              @input="changeItemPrice(item)"
                              :state="errors[0] ? false : (valid ? true : null)"
                              ></b-form-input>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                              </div>
                          </b-form-group>
                      </ValidationProvider>
                  </td>
                  <td>{{ item.total }}</td>
                </tr>
                <b-td colspan="9">
                    <p style="margin-left:85%">{{ $t('sales_center.grand_total') }}</p>
                </b-td>
                <b-td colspan="2">{{ getGrandTotal() }}</b-td>
              </table>
            </b-overlay>
            <b-row>
              <b-col lg="6" sm="12">
                  <ValidationProvider name="Delivery Date" vid='delivery_date' rules="required">
                      <b-form-group
                          class="row"
                          label-cols-sm="12"
                          label-for="delivery_date"
                          slot-scope="{ valid, errors }"
                      >
                          <template v-slot:label>
                          {{ $t('sales_distribution_admin.delivery_date')}} <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                          placeholder="Select Date"
                          id="delivery_date"
                          v-model="dataArray.delivery_date"
                          :state="errors[0] ? false : (valid ? true : null)"
                          ></b-form-input>
                          <div class="invalid-feedback">
                          {{ errors[0] }}
                          </div>
                      </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col lg="6" sm="12">
                <ValidationProvider name="Contact No" rules="required|max:11|min:11">
                <b-form-group class="row"
                  label-cols-sm="12"
                  label-for="contact_no"
                  slot-scope="{ valid, errors }"
                >
                  <template v-slot:label>
                    {{ $t("sales_distribution_admin.contact_person_no") }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="contact_no"
                    v-model="dataArray.contact_no"
                    :state="errors[0] ? false : (valid ? true : null)"
                  ></b-form-input>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col lg="6" sm="12">
                <ValidationProvider name="Delivery Place" rules="required">
                <b-form-group class="row" label-cols-sm="12" label-for="delivery_spot" slot-scope="{ valid, errors }">
                  <template v-slot:label>
                    {{ $t("sales_distribution_admin.delivery_spot") }} <span class="text-danger">*</span>
                  </template>
                  <b-textarea
                    rows="1"
                    id="delivery_spot"
                    v-model="dataArray.delivery_place"
                    :state="errors[0] ? false : (valid ? true : null)"
                  ></b-textarea>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col lg="6" sm="12"  v-if="currentLocale === 'en'">
                <b-form-group class="row" label-cols-sm="12" label-for="comment">
                  <template v-slot:label>
                    {{ $t("production_store.comment_en") }}
                  </template>
                  <b-textarea
                    rows="1"
                    id="comment"
                    v-model="dataArray.comment"
                  ></b-textarea>
                </b-form-group>
              </b-col>
              <b-col lg="6" sm="12" v-else>
                <b-form-group class="row" label-cols-sm="12" label-for="comment_bn">
                  <template v-slot:label>
                    {{ $t("production_store.comment_bn") }}
                  </template>
                  <b-textarea
                    id="comment_bn"
                    v-model="dataArray.comment_bn"
                  ></b-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="row">
              <b-col class="text-right">
                <b-button type="submit" variant="primary" class="mr-2">{{ $t('sales_distribution_admin.deliver') }}</b-button>
                                                    &nbsp;
                <b-button @click="cancel()" variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button>
              </b-col>
            </div>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>
  </b-overlay>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { availableStockInfo, deliveryOrderEntryApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      dataArray: {
        sales_center_id: '',
        d_id: '',
        demand_id: '',
        demand_date: '',
        delivery_date: '',
        delivery_place: '',
        contact_no: '',
        comment: '',
        comment_bn: '',
        details: []
      },
      freeProduct: {
        delivered_quantity: null,
        total: 0,
        unit_price: 0,
        category_id: 0,
        sub_category_id: 0,
        product_id: 0,
        unit_id: 0,
        quantity: 0,
        available_quantity: 0,
        delivery_quantity: 0,
        is_free: true
      },
      disableCat: true,
      disableSubCat: false,
      qtLoad: false,
      subCategoryList: [],
      productUnitList: [],
      productNList: [],
      productList: {},
      quantityList: '',
      PriceList: '',
      unitLoad: false,
      mat_id: 0,
      sl: 0,
      loading: false,
      givefree: false
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getDemandDetails()
      this.freeProduct.category_id = tmp.demmand_type
      this.dataArray.d_id = this.id
      this.dataArray.sales_center_id = tmp.sales_center_id
      this.dataArray.demand_id = tmp.demmand_id
      this.dataArray.demand_date = tmp.demmand_date
      this.dataArray.delivery_date = tmp.delivery_date
      this.dataArray.product_type = tmp.demmand_type
      this.dataArray.details = tmp.demand_details
      if (tmp.demmand_type === 1) {
        this.disableSubCat = false
        this.subCategoryList = this.getSubCatList(tmp.demmand_type)
      } else {
        this.disableSubCat = true
        this.freeProduct.sub_category_id = 0
      }
      this.productNList = this.getProductListByCat(tmp.demmand_type)
      const productIds = []
      const unitIds = []
      tmp.demand_details.forEach(productItem => {
        productIds.push(productItem.product_id)
        unitIds.push(productItem.unit_id)
      })
      this.productList = {
        product_ids: productIds,
        unit_ids: unitIds
      }
      this.getAvailableQuantity(this.productList)
    }
  },
  watch: {
    'freeProduct.sub_category_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.productNList = this.getProductList(newVal)
      }
    },
    'freeProduct.product_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
          this.productUnitList = this.getUnitList(newVal)
      }
    },
    'freeProduct.unit_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getProductStock(this.freeProduct.product_id, newVal)
      }
    },
    'freeProduct.delivery_quantity': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.freeProduct.quantity = newVal
      }
    }
  },
  mounted () {
    flatpickr('#delivery_date', {})
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    categoryList: function () {
      return this.productCommonObj.productCategoryList.filter(
        (item) => item.status === 1
      )
    },
    salesCenterList: function () {
      return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  methods: {
    changeItemQty (item) {
        if (item.unit_price) {
            const result = item.delivery_quantity * parseFloat(item.unit_price)
            item.total = parseFloat(result.toFixed(2))
        }
        if (item.available_quantity < parseFloat(item.delivery_quantity)) {
            item.message = 'Sales quantity must not be greater than available quantity'
        } else {
            item.message = ''
        }
    },
    changeItemPrice (item) {
        if (item.delivery_quantity) {
            const result = item.delivery_quantity * parseFloat(item.unit_price)
            item.total = parseFloat(result.toFixed(2))
        }
    },
    getGrandTotal () {
        const total = this.dataArray.details.reduce((total, item) => total + item.total, 0)
        return total
    },
    getProductStock (prodId, unId) {
      const productId = [prodId]
      const unitId = [unId]
      const productQuantityList = {
        product_ids: productId,
        unit_ids: unitId
      }
      this.qtLoad = true
      RestApi.getData(productionServiceBaseUrl, availableStockInfo, productQuantityList).then(response => {
        this.quantityList.push(response.data[0])
        this.PriceList.push(response.price[0])
        this.freeProduct.available_quantity = response.data[0].quantity
        this.freeProduct.unit_price = response.price[0].recommended_price
        this.qtLoad = false
      })
    },
    getUnitList (proId) {
      return this.productCommonObj.productUnitList.filter(item => item.product_id === proId && item.status === 1)
    },
    getSubCatList (catId) {
      return this.productCommonObj.productSubCategoryList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 2)
    },
    getProductListByCat (catId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 2)
    },
    getProductList (subCatId) {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.sub_category_id === subCatId && item.type_id === 2)
    },
    addFreeProduct () {
      const freeprod = this.freeProduct
      this.dataArray.details.push(freeprod)
    },
    checkGift () {
      if (this.givefree === false) {
        this.givefree = true
      } else {
        this.givefree = false
      }
    },
    getDemandDetails () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      const data = JSON.parse(JSON.stringify(tmpData))
      const demDetails = data.demand_details.map(item => {
        return Object.assign(item, { delivery_quantity: '', is_free: false, unit_price: 0, total: 0 })
      })
      return Object.assign(data, demDetails)
    },
    cancel () {
      this.$bvModal.hide('modal-2')
    },
    async saveData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }
      this.loading = true
      result = await RestApi.postData(productionServiceBaseUrl, deliveryOrderEntryApi, this.dataArray)
      loadingState.listReload = true

      this.$store.dispatch('mutateCommonProperties', loadingState)
      this.loading = false
      if (result.success) {
        if (result.notification && this.$store.state.emitNotification) {
            const notification = result.notification
            this.$socket.emit('send-notification', notification)
        }
        this.$store.dispatch('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })

        this.$bvModal.hide('modal-2')
      } else {
        this.$refs.form.setErrors(result.errors)
      }
    },
    getCategoryName (Id) {
      const product = this.productCommonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.productCommonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    },
    productNameById (id) {
      const product = this.productCommonObj.productList.find(
        (product) => product.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return product.text_bn
      } else {
        return product.text_en
      }
    },
    unitNameById (id) {
      const unit = this.productCommonObj.productUnitList.find(
        (unit) => unit.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return unit.text_bn
      } else {
        return unit.text_en
      }
    },
    getAvailableQuantity (products) {
      this.unitLoad = true
      RestApi.getData(productionServiceBaseUrl, availableStockInfo, products)
      .then(response => {
        this.quantityList = response.data
        this.PriceList = response.price
        this.dataArray.details = this.dataArray.details.map((item, index) => {
            return {
                ...item,
                unit_price: this.PriceList[index] ? this.PriceList[index].recommended_price : null
            }
        })
        this.unitLoad = false
      })
    },
    geAvailable (index) {
      if (this.quantityList[index]) {
        return this.quantityList[index].quantity
      } else {
        return 0
      }
    },
    getUnitPrice (index) {
      if (this.PriceList[index]) {
        return this.PriceList[index].recommended_price
      } else {
        return 0
      }
    },
    getSalesCenterName (id) {
      const salesCenter = this.salesCenterList.find(
        (salescenter) => salescenter.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return salesCenter.text_bn
      } else {
        return salesCenter.text_en
      }
    }
  }
}
</script>
